export default __webpack_public_path__ + "static/media/cold-drink.7f39a83f.svg";